import { useEffect } from 'react';

const LOCK_CLASS = 'ba-daw-lock';
let holders = 0;

/** Lock page scrolling while the full-window beat editor is mounted (ref-counted). */
export function useDawPageLock() {
  useEffect(() => {
    holders += 1;
    document.documentElement.classList.add(LOCK_CLASS);
    return () => {
      holders = Math.max(0, holders - 1);
      if (!holders) document.documentElement.classList.remove(LOCK_CLASS);
    };
  }, []);
}

export const DAW_LOCK_CLASS = LOCK_CLASS;
